import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
    CREATE_BRANCH,
    GET_SINGLE_BRANCH,
    GET_BRANCH_PRODUCTS,
    ACTIVATE_BRANCH,
    DEACTIVATE_BRANCH,
} from '../endPoints';
import { baseURL } from '../baseUrl/baseURL';
import { headers } from '../baseUrl/setHeaders';

export const branchAPI = createApi({
    reducerPath: 'branchAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: baseURL,
        prepareHeaders: headers,
    }),
    endpoints: (builder) => ({
        getBranchProducts: builder.query({
            query: (branch_id) => `${GET_BRANCH_PRODUCTS}${branch_id}`,
        }),
        getSingleBranch: builder.query({
            query: (branch_id) => `${GET_SINGLE_BRANCH}${branch_id}`,
        }),
        addBranch: builder.mutation({
            query: (branch) => ({
                url: `${CREATE_BRANCH}`,
                method: 'POST',
                body: branch,
            }),
        }),
        activateBranch: builder.mutation({
            query: (id) => ({
                url: `${ACTIVATE_BRANCH}/${id}`,
                method: 'POST',
                body: [],
            }),
        }),
        deactivateBranch: builder.mutation({
            query: (id) => ({
                url: `${DEACTIVATE_BRANCH}/${id}`,
                method: 'POST',
                body: [],
            }),
        }),
    }),
});

export const {
    useAddBranchMutation,
    useActivateBranchMutation,
    useDeactivateBranchMutation,
    useGetBranchProductsQuery,
    useGetSingleBranchQuery,
} = branchAPI;
